import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component'
import { take } from 'rxjs/operators';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageEvaluationFilterService {

  subscriptionCountryList: Subscription;
  subscriptionInstitution: Subscription;
  subscriptionDepartmentList: Subscription;
  subscriptionProfessionalCategory: Subscription;
  subscriptionWardList: Subscription;
  subscriptionSubCategoryList: Subscription;

  constructor(private layoutService: PHBHPLayoutPackageService) { }

  setFiltersValue(
    filterDetailsArray: PhBhpFilterComponent[],
    filtersArray: PhBhpFilterComponent[]
  ) {
    if (filterDetailsArray.length !== filtersArray.length) {
      return;
    }

    filterDetailsArray.forEach((filterDetails, index) => {
      const filter = filtersArray[index];
      this.setFilterValue(filterDetails, filter);
    });
  }

  setFilterValue(
    filterDetails: PhBhpFilterComponent,
    filter: PhBhpFilterComponent
  ) {

    filter.dateRange = filterDetails.dateRange;
    filter.selectDate();
    filter.setCountry = filterDetails.setCountry;
    filter.setInstitution = filterDetails.setInstitution;
    filter.setWard = filterDetails.setWard
    filter.setCategory = filterDetails.setCategory;
    filter.setSubCategory = filterDetails.setSubCategory;
    filter.setDepartment = filterDetails.setDepartment;
    // TODO Filters
    // if (filterDetails.country) {
    //   if (!filter.countryList) {
    //     this.subscriptionCountryList = filter.countryListSubject.asObservable().subscribe(res => {
    //       this.subscriptionCountryList.unsubscribe();
    //       filter.country = filter.countryList.find(c => c.countryID === filterDetails.country.countryID) ||
    //         { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
    //       if (!filterDetails.institution) {
    //         filter.getInstitutionByCountryId(filter.country.countryID).pipe(take(1)).subscribe();
    //       }
    //     });
    //   } else {
    //     filter.country = filter.countryList.find(c => c.countryID === filterDetails.country.countryID) ||
    //       { countryName: this.layoutService.translateText('EVALUATION.All.COUNTRIES') };
    //     if (!filterDetails.institution) {
    //       filter.getInstitutionByCountryId(filter.country.countryID).pipe(take(1)).subscribe();
    //     }
    //   }
    // }

    // if (filterDetails.institution) {
    //   if (!filter.institutionsList) {
    //     this.subscriptionInstitution = filter.institutionSubject.asObservable().subscribe(res => {
    //       this.subscriptionInstitution.unsubscribe();
    //       if (filter.institutionsList.length > 0) {
    //         if (filter.institutionsList[0]) {
    //           filter.institution = filter.institutionsList.find((list) => (list.institutionID == filterDetails.institution.institutionID) || (list.institutionName == filterDetails.institution.institutionName)) || 
    //             { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    //         } else {
    //           filter.institution = filter.institutionsList.find((list) => list.institutionID == filterDetails.institution.institutionID) ||
    //             { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    //         }
    //       } else {
    //         filter.institution = filter.institutionsList.find((list) => list.institutionID == filterDetails.institution.institutionID) ||
    //           { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };;
    //       }
    //       if (!filterDetails.ward) {
    //         filter.getWardsByInstitutionId(filter.institution.institutionID).pipe(take(1)).subscribe();;
    //       }
    //     });
    //   }
    //   else {
    //     if (filter.institutionsList.length > 0) {
    //       if (filter.institutionsList[0]) {
    //         filter.institution = filter.institutionsList.find((list) => (list.institutionID == filterDetails.institution.institutionID) || (list.institutionName == filterDetails.institution.institutionName)) ||
    //           { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    //       } else {
    //         filter.institution = filter.institutionsList.find((list) => list.institutionID == filterDetails.institution.institutionID) ||
    //           { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    //       }
    //     } else {
    //       filter.institution = filter.institutionsList.find((list) => list.institutionID == filterDetails.institution.institutionID) ||
    //         { institutionName: this.layoutService.translateText('EVALUATION.All.INSTITUTIONS') };
    //     }
    //     if (!filterDetails.ward && filter.institution) {
    //       filter.getWardsByInstitutionId(filter.institution.institutionID).pipe(take(1)).subscribe();
    //     }
    //   }
    // }

    // if (filterDetails.ward) {
    //   if (!filter.wardList) {
    //     filter.wardList = filterDetails.wardList;
    //     filter.ward = filterDetails.ward;
    //     this.subscriptionWardList = filter.wardListSubject.asObservable().subscribe(res => {
    //       this.subscriptionWardList.unsubscribe();
    //       filter.ward = filter.wardList.find((res1) => res1.wardID == filterDetails.ward.wardID) ||
    //         { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    //     });
    //   } else {
    //     filter.ward = filter.wardList.find((list) => list.wardID == filterDetails.ward.wardID) ||
    //       { wardName: this.layoutService.translateText('EVALUATION.All.WARDS') };
    //   }
    // }

    // if (filterDetails.department) {
    //   if (!filter.departmentList)
    //     this.subscriptionDepartmentList = filter.departmentListSubject.asObservable().subscribe(res => {
    //       this.subscriptionDepartmentList.unsubscribe();
    //       filter.department = filter.departmentList.find((res1) => res1.departmentID == filterDetails.department.departmentID) ||
    //         { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    //     });
    // }
    // else {
    //   filter.department = filter.departmentList.find((res1) => res1.departmentID == filterDetails.department.departmentID) ||
    //     { departmentName: this.layoutService.translateText('EVALUATION.All.DEPARTMENTS') };
    // }


    // if (filterDetails.category) {

    //   if (filter.institutionsList && filter.institutionsList.length > 0) {
    //     filter.setSubCategoriesVisibility();
    //     if (filter.subCategoryList) filter.subCategoryList = filter.subCategoryList.filter((list) => list.categoryID == filterDetails.category.categoryID)
    //     else if (filterDetails.subCategoryList) filter.subCategoryList = filterDetails.subCategoryList.filter((list) => list.categoryID == filterDetails.category.categoryID)
    //   }
  
    //   if (!filter.professionalCategoryList) {
    //     this.subscriptionProfessionalCategory = filter.professionalCategorySubject.asObservable().subscribe(res => {
    //       this.subscriptionProfessionalCategory.unsubscribe();
    //       filter.category = filter.professionalCategoryList.find((list) => list.categoryID == filterDetails.category.categoryID) ||
    //         { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    //     });
    //   }
    //   else {
    //     filter.category = filter.professionalCategoryList.find((list) => list.categoryID == filterDetails.category.categoryID) ||
    //       { categoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_CATEGORIES') };
    //   }
    //   if (!filterDetails.subCategory) {
    //     filter.getSubCategoryDetailsByCategoryId(filter.category.categoryID).pipe(take(1)).subscribe();
    //   }
    // }

    // if (filterDetails.subCategory) {
    //   if (!filter.subCategoryList) {
    //     this.subscriptionSubCategoryList = filter.subCategoryListSubject.asObservable().subscribe(res => {
    //       filter.subCategory = filter.subCategoryList.find((list) => list.subCategoryID == filterDetails.subCategory.subCategoryID) ||
    //         { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    //     });
    //   }
    //   else {
    //     filter.subCategory = filter.subCategoryList.find((list) => list.subCategoryID == filterDetails.subCategory.subCategoryID) ||
    //       { subCategoryName: this.layoutService.translateText('EVALUATION.All.PROFESSIONAL_SUB_CATEGORIES') };
    //   }
    // }
  }
}
